export default __webpack_public_path__ + "static/media/star-1-1.b3bc2f3a.svg";